import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconOpenAi24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconOpenAi24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M19.813 10.367a4.43 4.43 0 0 0-.39-3.683 4.62 4.62 0 0 0-4.95-2.176A4.57 4.57 0 0 0 11.043 3c-1.997-.004-3.77 1.265-4.384 3.14a4.54 4.54 0 0 0-3.04 2.175 4.49 4.49 0 0 0 .566 5.318 4.43 4.43 0 0 0 .39 3.684 4.62 4.62 0 0 0 4.951 2.175A4.57 4.57 0 0 0 12.955 21c1.999.005 3.772-1.265 4.386-3.142a4.54 4.54 0 0 0 3.04-2.176 4.49 4.49 0 0 0-.567-5.316zm-6.857 9.457a3.44 3.44 0 0 1-2.188-.781l.107-.06 3.633-2.07c.186-.104.3-.3.299-.51v-5.054l1.535.875a.05.05 0 0 1 .03.042v4.184c-.003 1.861-1.53 3.37-3.416 3.374m-7.344-3.096a3.32 3.32 0 0 1-.408-2.26l.108.064 3.632 2.07a.6.6 0 0 0 .597 0l4.435-2.527v1.75a.06.06 0 0 1-.022.046l-3.672 2.092c-1.635.93-3.724.377-4.67-1.235m-.957-7.824a3.4 3.4 0 0 1 1.78-1.479l-.002.124v4.14a.58.58 0 0 0 .298.51l4.435 2.527-1.536.874a.06.06 0 0 1-.051.005L5.906 13.51a3.353 3.353 0 0 1-1.251-4.606m12.614 2.897-4.435-2.527L14.37 8.4a.06.06 0 0 1 .051-.005l3.673 2.092a3.35 3.35 0 0 1 1.25 4.61 3.4 3.4 0 0 1-1.778 1.478V12.31a.58.58 0 0 0-.297-.51m1.528-2.27-.108-.063-3.633-2.07a.6.6 0 0 0-.596 0l-4.435 2.527v-1.75a.06.06 0 0 1 .022-.046l3.671-2.09c1.636-.932 3.727-.378 4.67 1.237a3.33 3.33 0 0 1 .407 2.255zM9.19 12.65l-1.535-.874a.05.05 0 0 1-.03-.042V7.55c.001-1.863 1.533-3.373 3.421-3.372.799 0 1.572.277 2.186.78l-.108.06-3.633 2.07a.58.58 0 0 0-.298.51zm.834-1.774L12 9.75l1.975 1.125v2.25L12 14.25l-1.976-1.125z"
            />
        </svg>
    );
}
export default memo(IconOpenAi24);
